import * as Types from './api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ButtonFragment = {
  __typename: 'ActionButton';
  textColor: string | null;
  backgroundColor: string | null;
  backgroundOpacityInPct: number | null;
  focusedTextColor: string | null;
  focusedBackgroundColor: string | null;
  focusedBackgroundOpacityInPct: number | null;
  outlineColor: string | null;
  text: string;
  color: Types.ButtonColor;
  action: {
    __typename: 'Action';
    tracking: {
      __typename: 'Tracking';
      details: Types.Scalars['Map']['output'];
      identifier: string;
    };
    clientAction:
      | { __typename: 'CloseClientAction' }
      | { __typename: 'GoToClientAction'; destination: string }
      | { __typename: 'IgnoreClientAction' }
      | { __typename: 'LogoutClientAction' };
    serverAction: { __typename: 'ServerAction'; mutationPayload: string } | null;
  };
};

export const ButtonFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Button' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionButton' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'backgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'backgroundOpacityInPct' } },
          { kind: 'Field', name: { kind: 'Name', value: 'focusedTextColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'focusedBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'focusedBackgroundOpacityInPct' } },
          { kind: 'Field', name: { kind: 'Name', value: 'outlineColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tracking' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientAction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'GoToClientAction' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'destination' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serverAction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'mutationPayload' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ButtonFragment, unknown>;
